import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { 
  LightBulbIcon,
  UserGroupIcon,
  MegaphoneIcon,
  EyeIcon,
  XMarkIcon
} from '@heroicons/react/24/outline';

interface MobileFABsProps {
  // Props are no longer needed since AI modal was removed
}

const MobileFABs: React.FC<MobileFABsProps> = () => {
  const [isVisible, setIsVisible] = useState(true);

  // Load visibility preference from localStorage on component mount
  useEffect(() => {
    const savedVisibility = localStorage.getItem('fab_visibility');
    if (savedVisibility !== null) {
      setIsVisible(savedVisibility === 'true');
    }
  }, []);

  const toggleVisibility = () => {
    const newVisibility = !isVisible;
    setIsVisible(newVisibility);
    // Save preference to localStorage
    localStorage.setItem('fab_visibility', newVisibility.toString());
  };

  return (
    <div className="fixed bottom-20 right-4 z-40 lg:hidden">
      {/* Feed FAB */}
      <div className={`transition-all duration-300 ease-in-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`}>
        <Link
          to="/app/feed"
          className="group block mb-3"
        >
          <div className="relative">
            <div className="w-14 h-14 bg-gradient-to-r from-green-500 to-emerald-500 rounded-full shadow-lg hover:shadow-xl transition-all duration-200 hover:scale-110 flex items-center justify-center">
              <MegaphoneIcon className="h-7 w-7 text-white" />
            </div>
            {/* Tooltip */}
            <div className="absolute right-16 top-1/2 transform -translate-y-1/2 bg-gray-900 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
              General Feed
              <div className="absolute left-full top-1/2 transform -translate-y-1/2 w-0 h-0 border-l-4 border-l-gray-900 border-t-2 border-t-transparent border-b-2 border-b-transparent"></div>
            </div>
          </div>
        </Link>
      </div>

      {/* Classroom FAB */}
      <div className={`transition-all duration-300 ease-in-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`}>
        <Link
          to="/app/classrooms"
          className="group block"
        >
          <div className="relative">
            <div className="w-14 h-14 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full shadow-lg hover:shadow-xl transition-all duration-200 hover:scale-110 flex items-center justify-center">
              <UserGroupIcon className="h-7 w-7 text-white" />
            </div>
            {/* Tooltip */}
            <div className="absolute right-16 top-1/2 transform -translate-y-1/2 bg-gray-900 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
              Classrooms
              <div className="absolute left-full top-1/2 transform -translate-y-1/2 w-0 h-0 border-l-4 border-l-gray-900 border-t-2 border-t-transparent border-b-2 border-b-transparent"></div>
            </div>
          </div>
        </Link>
      </div>

      {/* Toggle Button - Positioned at bottom when FABs are hidden */}
      <button
        onClick={toggleVisibility}
        className={`group block transition-all duration-300 ease-in-out ${
          isVisible ? 'mt-3' : 'mt-0'
        }`}
      >
        <div className="relative">
          <div className="w-8 h-8 bg-gray-600 hover:bg-gray-700 rounded-full shadow-lg hover:shadow-xl transition-all duration-200 hover:scale-110 flex items-center justify-center ml-3">
            {isVisible ? (
              <XMarkIcon className="h-4 w-4 text-white" />
            ) : (
              <EyeIcon className="h-4 w-4 text-white" />
            )}
          </div>
          {/* Tooltip */}
          <div className="absolute right-16 top-1/2 transform -translate-y-1/2 bg-gray-900 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
            {isVisible ? 'Hide FABs' : 'Show FABs'}
            <div className="absolute left-full top-1/2 transform -translate-y-1/2 w-0 h-0 border-l-4 border-l-gray-900 border-t-2 border-t-transparent border-b-2 border-b-transparent"></div>
          </div>
        </div>
      </button>


    </div>
  );
};

export default MobileFABs;
